import Dashboard from "../../../../pages/platforms/serviceEngineer/dashboard";
import BridgeDownloads from "../../../../pages/platforms/serviceEngineer/bridges";
import {
  MachineRegistry,
  MachineStock,
  MachineTieup,
} from "../../../../pages/platforms/serviceEngineer/machines";

const serviceEngineer = [
  {
    name: "Dashboard",
    path: "/bulletin",
    icon: "tachometer-alt",
    component: Dashboard,
  },

  {
    name: "Clients",
    path: "/clients",
    icon: "hospital",
    children: [
      {
        name: "My Clients",
        path: "/clients/list",
        icon: "building",
      },
      {
        name: "Contracts",
        path: "/clients/contracts",
        icon: "file-signature",
      },
      {
        name: "Visits",
        path: "/clients/visits",
        icon: "map-marker-alt",
      },
    ],
  },

  {
    name: "Service Desk",
    path: "/service-desk",
    icon: "headset",
    children: [
      {
        name: "Open Tickets",
        path: "/service-desk/open",
        icon: "exclamation-circle",
      },
      {
        name: "Assigned To Me",
        path: "/service-desk/assigned",
        icon: "user-cog",
      },
      {
        name: "For Visit",
        path: "/service-desk/visit",
        icon: "truck",
      },
      {
        name: "For Remote Support",
        path: "/service-desk/remote",
        icon: "desktop",
      },
      {
        name: "Pending Parts",
        path: "/service-desk/parts",
        icon: "cogs",
      },
      {
        name: "Resolved",
        path: "/service-desk/resolved",
        icon: "check-circle",
      },
    ],
  },

  {
    name: "Installations",
    path: "/installations",
    icon: "download",
    children: [
      {
        name: "Onboarding",
        path: "/installations/onboarding",
        icon: "tv",
      },
      {
        name: "Installed Machines",
        path: "/installations/machines",
        icon: "microscope",
      },
      {
        name: "Installed Bridges",
        path: "/installations/bridges",
        icon: "network-wired",
      },
    ],
  },

  {
    name: "Machines",
    path: "/machines",
    icon: "microscope",
    children: [
      {
        name: "Inventory",
        path: "/inventory/registry",
        icon: "list",
        component: MachineRegistry,
      },
      {
        name: "Stock",
        path: "/stocks",
        icon: "shield-alt",
        component: MachineStock,
      },
      {
        name: "Tieup",
        path: "/tieup",
        icon: "shield-alt",
        component: MachineTieup,
      },
      {
        name: "Calibration",
        path: "/machines/calibration",
        icon: "sliders-h",
      },
      {
        name: "Spare Parts",
        path: "/parts",
        icon: "cogs",
      },
    ],
  },

  {
    name: "LIS Bridges",
    path: "/bridges",
    icon: "network-wired",
    children: [
      {
        name: "Bridge Monitor",
        path: "/bridges/monitor",
        icon: "desktop",
      },
      {
        name: "Analyzer Mapping",
        path: "/bridges/mapping",
        icon: "project-diagram",
      },
      {
        name: "Logs",
        path: "/bridges/logs",
        icon: "file-alt",
      },
      {
        name: "Versions",
        path: "/bridges/versions",
        icon: "code-branch",
        component: BridgeDownloads,
      },
    ],
  },

  {
    name: "Maintenance",
    path: "/maintenance",
    icon: "tools",
    children: [
      {
        name: "Preventive Maintenance",
        path: "/pms",
        icon: "calendar-check",
      },
      {
        name: "Repairs",
        path: "/repairs",
        icon: "wrench",
      },
      {
        name: "Parts Replacement",
        path: "/parts",
        icon: "cogs",
      },
    ],
  },
  {
    name: "Schedules",
    path: "/schedules",
    icon: "calendar-alt",
    children: [
      {
        name: "My Schedule",
        path: "/schedules/calendar",
        icon: "calendar",
      },
      {
        name: "Field Visits",
        path: "/schedules/visits",
        icon: "truck",
      },
    ],
  },

  {
    name: "Reports",
    path: "/reports",
    icon: "file-medical",
    children: [
      {
        name: "Service Reports",
        path: "/reports/service",
        icon: "file-signature",
      },
      {
        name: "Completion Reports",
        path: "/reports/completion",
        icon: "clipboard-check",
      },
      {
        name: "Client Performance",
        path: "/reports/performance",
        icon: "chart-line",
      },
    ],
  },

  {
    name: "Settings",
    path: "/settings",
    icon: "sliders-h",
    children: [
      {
        name: "Machine Types",
        path: "/settings/machine-types",
        icon: "microscope",
      },
      {
        name: "Bridge Versions",
        path: "/settings/bridge-versions",
        icon: "code-branch",
        component: BridgeDownloads,
      },
      {
        name: "Service Categories",
        path: "/settings/categories",
        icon: "tags",
      },
    ],
  },
];

export default serviceEngineer;
